import { render, staticRenderFns } from "./CommunityAdd.vue?vue&type=template&id=20b35df8"
import script from "./CommunityAdd.vue?vue&type=script&lang=js"
export * from "./CommunityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports